import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { BrowserModule } from '@angular/platform-browser';
import {
  AreaRangeWithLineChartComponent
} from '@components/pages/charts/area-range-with-line-chart/area-range-with-line-chart.component';
import { HighchartsChartComponent } from '@components/pages/charts/highcharts-chart/highcharts-chart.component';
import { ImageContentSafeImageUrlPipe } from '@components/pages/charts/image-content/image-content-safe-image-url.pipe';
import { ImageContentComponent } from '@components/pages/charts/image-content/image-content.component';
import { MapContentComponent } from '@components/pages/charts/map-content/map-content.component';
import { StatusItemComponent } from '@components/pages/charts/status-item/status-item.component';
import { TextContentComponent } from '@components/pages/charts/text-content/text-content.component';
import { HighchartsChartComponent as HcChartComponent } from 'highcharts-angular';
import { CommandContentComponent } from './command-content/command-content.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { CommandContentModalComponent } from './command-content/command-content-modal/command-content-modal.component';

@NgModule({
  declarations: [
    AreaRangeWithLineChartComponent,
    ImageContentComponent,
    MapContentComponent,
    StatusItemComponent,
    TextContentComponent,
    HighchartsChartComponent,
    ImageContentSafeImageUrlPipe,
    CommandContentComponent,
    CommandContentModalComponent

  ],
  exports: [
    AreaRangeWithLineChartComponent,
    ImageContentComponent,
    MapContentComponent,
    StatusItemComponent,
    TextContentComponent,
    HighchartsChartComponent,
    CommandContentComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    HcChartComponent,
    GoogleMapsModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    TranslateModule,
    SharedModule
]
})
export class ChartsModule {
}
